export default __webpack_public_path__ + "static/media/logo.c796ba8d.png";